export class MapEventHandler {
  constructor(mapEngine) {
    this.mapEngine = mapEngine
    this.map = null
    this.boundHandlers = {}
  }

  bindEvents() {
    this.map = this.mapEngine.map
    if (!this.map) return

    this.boundHandlers.click = (e) => this._handleMapClick(e)
    this.map.on('click', this.boundHandlers.click)

    this.boundHandlers.moveend = () => this._handleMoveEnd()
    this.map.on('moveend', this.boundHandlers.moveend)

    this._setupTouchGestures()
  }

  unbindEvents() {
    if (!this.map) return

    Object.entries(this.boundHandlers).forEach(([event, handler]) => {
      this.map.off(event, handler)
    })

    this.boundHandlers = {}
  }

  _handleMapClick(e) {
    const { lat, lng } = e.latlng

    if (this.mapEngine.onMapClick) {
      this.mapEngine.onMapClick({ lat, lng })
    }

    if (this.mapEngine.onPointSelected) {
      this.mapEngine.onPointSelected({ lat, lng })
    }
  }

  _handleMoveEnd() {
    const viewState = this.mapEngine.getViewState()

    window.dispatchEvent(
      new CustomEvent('map:viewchanged', {
        detail: viewState
      })
    )
  }

  _setupTouchGestures() {
    if (!this.map) return

    this.map.touchZoom.enable()
    this.map.doubleClickZoom.enable()
  }
}
